import { SectionLabel } from "main/Main";
import React from "react";
import styled from "styled-components";
import { ReactComponent as Minus } from "../../assets/minus.svg";
import { ReactComponent as Plus } from "../../assets/plus.svg";

interface Props {
  adultCount: number;
  youthCount: number;
  updateAdultCount: React.Dispatch<React.SetStateAction<number>>;
  updateYouthCount: React.Dispatch<React.SetStateAction<number>>;
}
const PeopleCount: React.FC<Props> = (props) => {
  const increaseAdult = () => {
    if (props.adultCount >= 30) return;
    props.updateAdultCount((prev) => prev + 1);
  };

  const decreaseAdult = () => {
    if (props.adultCount <= 0) return;
    props.updateAdultCount((prev) => prev - 1);
  };

  const increaseYouth = () => {
    if (props.youthCount >= 30) return;
    props.updateYouthCount((prev) => prev + 1);
  };

  const decreaseYouth = () => {
    if (props.youthCount <= 0) return;
    props.updateYouthCount((prev) => prev - 1);
  };

  return (
    <Container>
      <SectionLabel>인원을 추가해 주세요!</SectionLabel>
      <PeopleRow>
        <PeopleLabel>성인</PeopleLabel>
        <PeopleContainer>
          <Minus className="minus" onClick={decreaseAdult} />
          <span className="people__count">{`${props.adultCount}명`}</span>
          <Plus className="plus" onClick={increaseAdult} />
        </PeopleContainer>
      </PeopleRow>
      <PeopleRow>
        <PeopleLabel>청소년</PeopleLabel>
        <PeopleContainer>
          <Minus className="minus" onClick={decreaseYouth} />
          <span className="people__count">{`${props.youthCount}명`}</span>
          <Plus className="plus" onClick={increaseYouth} />
        </PeopleContainer>
      </PeopleRow>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px 40px;
`;

const PeopleRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;

  &:not(:last-child) {
    margin-bottom: 10px;
  }
`;

const PeopleLabel = styled.span`
  font-size: 15px;
  font-weight: bold;
  min-width: 50px;
  color: #000000;
`;

const PeopleContainer = styled.div`
  flex: 1;
  height: 50px;
  border: 1px solid var(--color__border);
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  user-select: none;

  gap: 10px;

  .minus {
    width: 47px;
    height: 47px;
    cursor: pointer;
  }
  .people__count {
    font-size: 16px;
    font-weight: bold;
    color: #000000;
  }

  .plus {
    width: 47px;
    height: 47px;
    cursor: pointer;
  }
`;

export default PeopleCount;
